module.exports = __webpack_public_path__ + "static/media/IT-Consulting.991e7ad7.svg";